const helper = {
    cloneItem(value) {
        return JSON.parse(JSON.stringify(value));
    }
}

export default helper;